import React from "react";
import { useTranslation } from "react-i18next";
import "./content.css";

// The label every editorial FAQ carries: written by the editorial team,
// never by a visitor or a lawyer.
export default function EditorialBadge({ compact = false }) {
  const { t } = useTranslation();
  return (
    <span className={"avc-editorial-badge" + (compact ? " avc-editorial-badge--compact" : "")}>
      <i className="fas fa-feather-alt" aria-hidden="true"></i>
      {t("faq_editorial_badge")}
    </span>
  );
}
